import { DevicesAppView } from '../view/DevicesAppView';
import { templateDevicesApp } from '../view/template';
import { DevicesAppRepository } from '../repository/DevicesAppRepository';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { DevicesAppWebComponent } from '..';
import { ColumnKeys, ColumnKeys as DevicesColumnKeys, DevicesAppWebComponentSchema } from '../types';
import {
  getSideNavigationPanelSmartViewsListener,
  getSmartViewsListeners,
} from '../../../grid/genericGridSmartViews/utils';
import { GridEvents } from '../../../grid/types/common';
import { DevicesSideMenuWebComponent } from '../../sideMenus/devicesSideMenu';
import {
  buildPatchAppAction,
  createActionDialog,
  createFratDialog,
  renderDialogText,
  RiskManagementSideMenuEvents,
} from '../../sideMenus/common/common';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import {
  buildPatchManagementInformation,
  handleChangeStateBulkSelectionChanged,
  handleChangeWatchlistBulkSelectionChanged,
  handleComplexEnumFilter,
  handlePivotFromExtraDetailsPanelToAdvancedSearch,
  handlePivotFromExtraDetailsPanelToIncidents,
  handleRowsLoadingFinishedEvent,
  handleScan,
  handleSelectionChange,
  isCloudResource,
  overlayOpenListener,
  updateWatchlist,
} from '../../common/utils';
import { ColumnKeys as UsersColumnKeys } from '../../usersApp/types';
import { ColumnKeys as MisconfigurationsColumnKeys } from '../../misconfigurationsApp/types';
import { translateFn } from '../../../utils/translator.helper';
import {
  Actions,
  AppIds,
  DetailsType,
  InlineMenuExtraDetailsSelectEvents,
  IsolationStatus,
  MitigationType,
} from '../../common/constants';
import { ActionsEvents } from '../../common/constants';
import { WEB_COMPONENT_DEVICES_SIDE_MENU } from '../../../webcomponents.constants';
import { ToastActionButtonMode, ToastSeverity } from '../../../ui/gzToastNotification/type';
import { showToast } from '../../../tagsManager/helpers/commonFunctions';
import { ShowExtraDataEventDetails } from '../../sideMenus/components/deviceDetails/types/types';

import { convertGridFiltersToExtJsFilters } from '../../../grid/utils/filters';
import { ButtonEvents, GzButtonState } from '../../../ui/gzButton/types';
import { SelectEvents } from '../../../ui/gzSelect/types';
import { ContextMenuOverlayEvents } from '../../../ui/gzContextMenuOverlay/component/gzContextMenuOverlay';
import { NavigationHelper } from '@nirvana/shared/navigation';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { GzButtonWebComponent } from '../../../ui/gzButton';
import { GzDialog } from '../../../ui/gzDialog/component/GzDialog';
import { GzDialogWebComponent } from '../../../ui/gzDialog';
import { EventTypes, SelectedListItem } from '../../../ui/gzSelectedListItemGenerator/types';
import { isEmpty } from 'lodash';
import { GzSelectedListItemGeneratorWebComponent } from '../../../ui/gzSelectedListItemGenerator';
import { GzToastNotificationWebComponent } from '../../../ui/gzToastNotification';
import { navigateToTasksSection } from '../../../utils/navigation.utils';
import { MisconfigurationsNames } from '../../common/callbacks/MisconfigurationsNames';
import { Feature } from '@nirvana/shared/constants';

export class DevicesAppController extends BaseWebComponentController {
  public component: DevicesAppWebComponent;
  public dataRepository: DevicesAppRepository;
  public view: DevicesAppView;
  public viewConstructor: typeof DevicesAppView;
  public dataRepositoryConstructor: typeof DevicesAppRepository;

  public confirmButton;

  selectedItems: Array<any>;

  constructor(component: DevicesAppWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: DevicesAppView,
      viewTemplate: templateDevicesApp,
      dataRepositoryConstructor: DevicesAppRepository,
    });
  }

  public computeEventListeners() {
    return [
      ...getSmartViewsListeners(
        this.view.dom.$grid,
        this.view.dom.$gridSmartViews,
        this.view.buildGrid.bind(this.view),
        this.view.getTranslations()
      ),
      ...getSideNavigationPanelSmartViewsListener(this.view.dom.$pushBodyLayout, this.view.dom.$gridSmartViews),
      {
        element: this.view.dom.$grid,
        event: GridEvents.ROW_CLICKED,
        callback: this.handleRowClicked,
      },
      {
        element: this.view.dom.$grid,
        event: GridEvents.ROWS_LOADING_FINISHED,
        callback: handleRowsLoadingFinishedEvent.bind(this),
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.VIEW_DEVICES_BY_MISCONFIGURATION,
        callback: this.handleViewDevicesByMisconfigurationEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.VIEW_MISCONFIGURATION_DETAILS,
        callback: this.handleViewMisconfigurationDetailsEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.VIEW_USERS_BY_DEVICE,
        callback: this.handleViewUsersEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.IGNORE_DEVICES,
        callback: this.handleIgnoreDevicesEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.RESTORE_DEVICES,
        callback: this.handleRestoreDevicesEvent,
      },
      {
        element: this.view.dom.$grid,
        event: RiskManagementSideMenuEvents.IGNORE_DEVICES,
        callback: this.handleIgnoreDevicesEvent,
      },
      {
        element: this.view.dom.$grid,
        event: RiskManagementSideMenuEvents.RESTORE_DEVICES,
        callback: this.handleRestoreDevicesEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.ISOLATE_DEVICE,
        callback: this.handleIsolateDeviceEvent,
      },
      {
        element: this.view.dom.$grid,
        event: RiskManagementSideMenuEvents.ISOLATE_DEVICE_INLINE_MENU,
        callback: this.handleIsolateDeviceInlineMenuEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.REMOVE_FROM_ISOLATION,
        callback: this.handleRemoveFromIsolationEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.FIX_MISCONFIGURATIONS,
        callback: this.handleFixMisconfigurationsEvent,
      },
      {
        element: this.view.dom.$grid,
        event: RiskManagementSideMenuEvents.FIX_MISCONFIGURATIONS_INLINE,
        callback: this.handleFixMisconfigurationsInlineEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.ROLLBACK_DEVICES,
        callback: this.handleRollbackDevicesEvent,
      },
      {
        element: this.view.dom.$grid,
        event: RiskManagementSideMenuEvents.ROLLBACK_DEVICES_INLINE,
        callback: this.handleRollbackDevicesInlineEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.VIEW_INCIDENTS_BY_DEVICE,
        callback: this.handleViewIncidentsEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.VIEW_INCIDENTS_BY_DEVICE_CLOUD,
        callback: this.handleViewIncidentsCloudEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.VIEW_EVENTS_AND_ALERTS_BY_DEVICE,
        callback: this.handleViewEventsAndAlertsEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: ActionsEvents.WATCHLIST_CHANGED,
        callback: this.handleWatchlistChangedEvent,
      },
      {
        element: this.view.dom.$grid,
        event: ActionsEvents.WATCHLIST_CHANGED,
        callback: this.handleWatchlistChangedEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.PATCH_APP,
        callback: this.handlePatchAppEvent,
      },
      {
        element: this.view.dom.$sideMenu,
        event: RiskManagementSideMenuEvents.DEVICE_DETAILS_SHOW_EXTRA_DATA,
        callback: this.handleDeviceDetailsShowExtraDataEvent,
      },
      {
        element: this.view.dom.$grid,
        event: GridEvents.EXPORT_CSV,
        callback: this.handleCSVExportEvent,
      },
      {
        element: this.view.dom.$grid,
        event: GridEvents.SELECT_ROWS,
        callback: this.handleSelectionChange,
      },
      {
        element: this.view.dom.changeStateBulk.$select,
        event: SelectEvents.SELECTION_CHANGED,
        callback: (event: CustomEvent) => {
          handleChangeStateBulkSelectionChanged.call(this, event, 'endpointId');
        },
      },
      {
        element: this.view.dom.changeWatchlistBulk.$select,
        event: SelectEvents.SELECTION_CHANGED,
        callback: handleChangeWatchlistBulkSelectionChanged.bind(this),
      },
      {
        element: this.view.dom.fixBulk.$button,
        event: ButtonEvents.CLICK,
        callback: this.handleFixBulkButtonClick,
      },
      {
        element: this.view.dom.$scanEmptyStateButton,
        event: ButtonEvents.CLICK,
        callback: handleScan.bind(this),
      },
      {
        element: this.view.dom.scanButton.$button,
        event: ButtonEvents.CLICK,
        callback: handleScan.bind(this),
      },
      {
        element: this.view.dom.$sideMenu,
        event: InlineMenuExtraDetailsSelectEvents.viewIncidents,
        callback: handlePivotFromExtraDetailsPanelToIncidents.bind(this),
      },
      {
        element: this.view.dom.$sideMenu,
        event: InlineMenuExtraDetailsSelectEvents.viewEvents,
        callback: handlePivotFromExtraDetailsPanelToAdvancedSearch.bind(this),
      },
      {
        // This was needed in order to modify the pointer-events attribute on body
        // It was being set on none at overlay opening and was preventing
        // automated tests to click on other elements while the overlay was open
        element: this.view.dom.$overlay,
        event: ContextMenuOverlayEvents.OPEN,
        callback: overlayOpenListener,
      },
    ];
  }

  async getDataForView(): Promise<DevicesAppWebComponentSchema> {
    return {
      data: await this.dataRepository.getDataForView(),
      externalFilters: this.component.externalFilters,
    };
  }

  async handleRowClicked(event: CustomEvent) {
    if (!event.detail.rowDetails) {
      // header was clicked, so we do nothing
      return;
    }

    const component = new DevicesSideMenuWebComponent();
    component.item = event.detail.rowDetails;

    this.view.dom.$sideMenu.setMenuContent(component);
    this.view.dom.$sideMenu.openSideMenu();

    try {
      component.item.countRisksToRollback = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'CompanyEndpointRollbackState',
        method: 'countRisksToRollbackByEndpointId',
        payload: {
          companyId: event.detail.rowDetails.company._id,
          endpointId: event.detail.rowDetails.endpointId,
        },
      });
    } catch (e) {
      component.item.countRisksToRollback = 0;
    }

    try {
      component.tabsDetails = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'RiskManagementDevices',
        method: 'getDataForDevice',
        payload: {
          companyId: event.detail.rowDetails.companyId,
          endpointId: event.detail.rowDetails.endpointId,
        },
      });
    } catch (error) {
      // do nothing
      component.deviceDetailsHasErrors = true;
    }

    if (!component.tabsDetails) {
      return;
    }

    const applicationIds = component.tabsDetails.vulnerabilities.map(vulnerability => vulnerability._id);

    let patchDataResponse: any = null;

    try {
      const hasPatchManagement = event.detail.rowDetails.company?.specifics?.features?.patchManagementUsable ?? false;
      const isCompanionStandalone = event.detail.rowDetails.company?.specifics?.features?.companionStandalone ?? false;

      patchDataResponse = hasPatchManagement
        ? await ConsoleRequest.createRequest<any>({
            dataProviderType: DataProviderType.CORE,
            endpoint: 'Vulnerabilities',
            method: 'getPatchManagementInformation',
            payload: {
              applicationIds: applicationIds,
              companyId: event.detail.rowDetails.company._id,
              endpointId: event.detail.rowDetails.endpointId,
            },
          })
        : applicationIds.map(applicationId => ({ applicationId, hasPatchManagement: false }));

      const patchManagementDetails = {};
      if (patchDataResponse && Array.isArray(patchDataResponse) && patchDataResponse.length > 0) {
        for (const applicationPatchInformation of patchDataResponse) {
          patchManagementDetails[applicationPatchInformation['applicationId']] = buildPatchManagementInformation(
            applicationPatchInformation['applicationId'],
            applicationPatchInformation,
            isCompanionStandalone
          );
        }

        component.patchManagementDetails = patchManagementDetails;
      }
    } catch (error) {
      //do nothing
    }

    this.enhanceSideMenuWithExtraDetailsData(component);
  }

  private enhanceSideMenuWithExtraDetailsData(deviceSideMenuComponent) {
    const deviceExtraDetails = {
      [DetailsType.VULNERABILITIES]: {},
      [DetailsType.MISCONFIGURATION]: {},
    };

    deviceSideMenuComponent.tabsDetails.vulnerabilities.map(vulnerability => {
      deviceExtraDetails[DetailsType.VULNERABILITIES][vulnerability._id] = vulnerability.extraDetails;
    });

    deviceSideMenuComponent.tabsDetails.misconfigurations.map(misconfiguration => {
      deviceExtraDetails[DetailsType.MISCONFIGURATION][misconfiguration._id] = misconfiguration.extraDetails;
    });

    deviceSideMenuComponent.deviceDetails = deviceExtraDetails;
  }

  private handleViewDevicesByMisconfigurationEvent(event: CustomEvent) {
    const { indicatorId, companyId } = event.detail;
    const params = {
      filters: [
        {
          [DevicesColumnKeys.DEVICE_MISCONFIGURATIONS]: { complexEnumFilter: [{ value: indicatorId }] },
        },
        {
          [DevicesColumnKeys.COMPANY]: { exactMatch: companyId },
        },
      ],
    };
    NavigationHelper.navigateTo('/risk-management-resources', params);
  }

  handleViewUsersEvent(event: CustomEvent) {
    const { device, companyId } = event.detail;
    const params = {
      filters: [
        {
          [UsersColumnKeys.USER_DEVICES]: {
            complexEnumFilter: [device],
          },
        },
        {
          [UsersColumnKeys.COMPANY]: { exactMatch: companyId },
        },
      ],
    };

    NavigationHelper.navigateTo('/risk-management-identities', params);
  }

  handleIgnoreDevicesEvent(event: CustomEvent) {
    const { endpointsIds, companyId } = event.detail;

    this.createIgnoreDialog(endpointsIds, companyId);
  }

  handleRestoreDevicesEvent(event: CustomEvent) {
    const { endpointsIds, companyId } = event.detail;

    this.createRestoreDialog(endpointsIds, companyId);
  }

  private handleIsolateDeviceEvent(event: CustomEvent) {
    const { companyId, endpointId } = event.detail;

    let dialogConfig = {};

    dialogConfig = {
      dialogTitle: translateFn('Isolate?'),
      confirmButtonText: translateFn('Isolate'),
      dialogBodyMessage: `
         ${renderDialogText(translateFn('The selected resource will be isolated from your network and the internet.'))}
         ${renderDialogText(translateFn('You can revert this action at any time.'))}`,
    };

    const requestPayload = {
      parameters: {
        actionType: Actions.ISOLATE_DEVICE,
        companyId: companyId,
        data: {
          endpointId: endpointId,
          isIsolated: true,
        },
      },
    };

    createActionDialog(
      dialogConfig,
      {
        grid: this.view.dom.$grid,
        sideMenu: this.view.dom.$sideMenu,
      },
      requestPayload,
      {
        success: translateFn('The Isolate task has been successfully created.'),
        error: translateFn('Failed to create the Isolate task.'),
      },
      true,
      true
    );
  }

  private handleRemoveFromIsolationEvent(event: CustomEvent) {
    const { companyId, endpointId } = event.detail;

    let dialogConfig = {};

    dialogConfig = {
      dialogTitle: translateFn('Remove resource from isolation?'),
      confirmButtonText: translateFn('Remove'),
      dialogBodyMessage: `
         ${renderDialogText(translateFn('The selected resource will be removed from isolation.'))}
         ${renderDialogText(translateFn('You can revert this action at any time.'))}`,
    };

    const requestPayload = {
      parameters: {
        actionType: Actions.ISOLATE_DEVICE,
        companyId: companyId,
        data: {
          endpointId: endpointId,
          isIsolated: false,
        },
      },
    };

    createActionDialog(
      dialogConfig,
      {
        grid: this.view.dom.$grid,
        sideMenu: this.view.dom.$sideMenu,
      },
      requestPayload,
      {
        success: translateFn('The Remove from isolation task has been successfully created.'),
        error: translateFn('Failed to create the Remove from isolation task.'),
      },
      true,
      true
    );
  }

  private async handleIsolateDeviceInlineMenuEvent(event: CustomEvent) {
    let isolationStatus: any = null;
    try {
      isolationStatus = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'RiskManagementDevices',
        method: 'getIsolationStatus',
        payload: {
          endpointId: event.detail.endpointId,
          companyId: event.detail.companyId,
        },
      });
    } catch (error) {
      // do nothing
    }

    switch (isolationStatus?.data.status) {
      case IsolationStatus.ISOLATION_STATUS_ISOLATED:
        this.handleRemoveFromIsolationEvent(event);
        break;
      case IsolationStatus.ISOLATION_STATUS_NOT_ISOLATED:
        this.handleIsolateDeviceEvent(event);
        break;
      case IsolationStatus.ISOLATION_STATUS_PENDING_ISOLATION:
        showToast(ToastSeverity.ERROR, translateFn('Unable to create task. Another isolation task is in progress.'));
        break;
      case IsolationStatus.ISOLATION_STATUS_PENDING_RESTORE:
        showToast(ToastSeverity.ERROR, translateFn('Unable to create task. A restoration task is in progress.'));
        break;
      default:
        showToast(
          ToastSeverity.ERROR,
          event.detail.appId !== AppIds.APPID_UNIFIED_CLIENT
            ? translateFn(
                'Unable to create task. The target resource is not an endpoint or does not have the EDR Sensor installed.'
              )
            : translateFn('Unable to create task.')
        );
    }
  }

  private handleFixMisconfigurationsEvent(event: CustomEvent) {
    const { indicatorsIds, endpointsIds, companyId, hasFrat } = event.detail;

    this.createFixDialog(indicatorsIds, endpointsIds, companyId, hasFrat);
  }

  private async handleFixMisconfigurationsInlineEvent(event: CustomEvent) {
    let mitigationData = [];
    try {
      mitigationData = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'RiskManagementDevices',
        method: 'getMitigationDataForDevice',
        payload: {
          companyId: event.detail.companyId,
          endpointId: event.detail.endpointsIds[0],
        },
      });
    } catch (error) {
      // do nothing
    }

    const automaticMitigations = mitigationData.filter(
      (misconfiguration: any) => misconfiguration.mitigation === MitigationType.AUTOMATIC
    );

    if (automaticMitigations.length === 0) {
      showToast(
        ToastSeverity.ERROR,
        translateFn('Automatic mitigation is not applicable for any of the risks affecting the endpoint.')
      );
    } else {
      this.handleFixMisconfigurationsEvent(event);
    }
  }

  private createFixDialog(
    indicatorsIds: Array<number>,
    endpointsIds: Array<string>,
    companyId: string,
    hasFrat: boolean
  ) {
    if (hasFrat) {
      createFratDialog();
      return;
    }

    let dialogConfig = {};
    if (indicatorsIds && indicatorsIds.length > 0) {
      let indicatorsText: string;
      if (indicatorsIds.length === 1) {
        indicatorsText = translateFn(
          'The recommended settings will be applied for fixing the {MISCONFIGURATION_NAME} risk.',
          {
            MISCONFIGURATION_NAME:
              Application.modules.riskManagement.controller.helpers.routinesTranslations.translateRoutineName(
                indicatorsIds[0]
              ),
          }
        );
      } else {
        indicatorsText = translateFn(
          'The recommended settings will be applied for fixing {NUMBER_OF_MISCONFIGURATIONS} risks.',
          {
            NUMBER_OF_MISCONFIGURATIONS: indicatorsIds.length,
          }
        );
      }

      const dialogBodyMessage = `
        ${renderDialogText(indicatorsText)}
        ${renderDialogText(
          translateFn('A task will be automatically created to apply the settings to the selected resources.')
        )}
      `;
      dialogConfig = {
        dialogTitle: translateFn('Fix risk?'),
        confirmButtonText: translateFn('Fix risk'),
        dialogBodyMessage,
      };
    } else {
      if (endpointsIds.length === 1) {
        dialogConfig = {
          dialogTitle: translateFn('Fix risks?'),
          confirmButtonText: translateFn('Fix risks'),
          dialogBodyMessage: `
          ${renderDialogText(
            translateFn(
              'The recommended settings will be applied for all related risks that can be automatically resolved.'
            )
          )}
          ${renderDialogText(
            translateFn('A task will be automatically created to apply the settings to the selected resources.')
          )}
        `,
        };
      } else {
        dialogConfig = {
          dialogTitle: translateFn('Fix risks?'),
          confirmButtonText: translateFn('Fix risks'),
          dialogBodyMessage: `
          ${renderDialogText(
            translateFn(
              'The recommended settings will be applied for all related risks that can be automatically resolved.'
            )
          )}
          ${renderDialogText(
            translateFn('A task will be automatically created to apply the settings to the selected resources.')
          )}
        `,
        };
      }
    }

    const requestPayload = {
      parameters: {
        actionType: Actions.FIX_MISCONFIGURATIONS,
        indicatorsIds,
        companyId,
        endpointsIds,
      },
    };
    createActionDialog(
      dialogConfig,
      {
        grid: this.view.dom.$grid,
        sideMenu: this.view.dom.$sideMenu,
      },
      requestPayload,
      {
        success: translateFn('Task created successfully'),
        error: translateFn('Failed to create task'),
      },
      true
    );
  }

  private async handleViewIncidentsEvent(event: CustomEvent) {
    if (event.type === RiskManagementSideMenuEvents.VIEW_INCIDENTS_BY_DEVICE) {
      Application.lib.Navigation.openInNewTab(`/incidents/filter/entity/${event.detail.endpointId}`);
    }
  }

  private async handleViewIncidentsCloudEvent(event: CustomEvent) {
    if (event.type === RiskManagementSideMenuEvents.VIEW_INCIDENTS_BY_DEVICE_CLOUD) {
      Application.lib.Navigation.openInNewTab(
        `/incidents/filter/cloudresource/${event.detail.companyId}&${encodeURIComponent(event.detail.resourceName)}`
      );
    }
  }

  private async handleViewEventsAndAlertsEvent(event: CustomEvent) {
    if (event.type === RiskManagementSideMenuEvents.VIEW_EVENTS_AND_ALERTS_BY_DEVICE) {
      Application.lib.Navigation.openInNewTab(`/xdr/device/${event.detail.endpointId}`);
    }
  }

  private handleViewMisconfigurationDetailsEvent(event: CustomEvent) {
    const { indicatorId, companyId } = event.detail;
    const params = {
      filters: [
        {
          [MisconfigurationsColumnKeys.MISCONFIGURATION_NAME]: {
            complexEnumFilter: [{ value: indicatorId }],
          },
        },
        {
          [MisconfigurationsColumnKeys.COMPANY]: { exactMatch: companyId },
        },
      ],
      openSideMenuForFirstItem: true,
    };

    NavigationHelper.navigateTo('/risk-management-findings', params);
  }

  private async handleWatchlistChangedEvent(event: CustomEvent) {
    const { newWatchlist, ids, companyId } = event.detail;
    await this.updateWatchlistStatus(newWatchlist, ids, companyId);
  }

  private handlePatchAppEvent(event: CustomEvent) {
    buildPatchAppAction(event, this.view.dom.$grid, this.view.dom.$sideMenu);
  }

  private async handleDeviceDetailsShowExtraDataEvent(event: CustomEvent) {
    const sideMenuComponent = this.view.dom.$sideMenu.querySelector(
      WEB_COMPONENT_DEVICES_SIDE_MENU
    ) as DevicesSideMenuWebComponent;

    const details: ShowExtraDataEventDetails = event.detail;

    sideMenuComponent.showExtraDetailsPanel = details.showExtraDetailsPanel;

    if (details.extraDetailsPanelTitle) {
      sideMenuComponent.extraDetailsPanelTitle = details.extraDetailsPanelTitle;
    }

    sideMenuComponent.deviceExtraDetails = {
      items: details.items,
      itemsType: details.itemsType,
      companyId: details.companyId,
    };
  }

  private handleCSVExportEvent(event: CustomEvent) {
    this.view.dom.$grid.controller?.updateCsvButtonState(
      GzButtonState.IS_LOADING,
      this.dependencies.translateFn('Change the current filter selection to generate a new export.')
    );

    // if you change something here, change in GridDataProvider.getSummary also
    let filters: any[] = convertGridFiltersToExtJsFilters(event.detail.filters);
    const complexEnumFilterColumns = [
      DevicesColumnKeys.DEVICE_NAME,
      DevicesColumnKeys.REGION,
      DevicesColumnKeys.DEVICE_FQDN,
      DevicesColumnKeys.DEVICE_MACS,
      DevicesColumnKeys.DEVICE_CVES,
      DevicesColumnKeys.DEVICE_MISCONFIGURATIONS,
      DevicesColumnKeys.DEVICE_IP,
      DevicesColumnKeys.RESOURCE_ID,
      DevicesColumnKeys.CLOUD_ACCOUNT,
      ...Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_BCST_IMAGE_SCANNER_USABLE])
        ? [
          DevicesColumnKeys.REPOSITORY_NAME,
          DevicesColumnKeys.REGISTRY_HOST
        ]
        : [],
      ...Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_KSPM_USABLE])
        ? [
          DevicesColumnKeys.CLUSTER_NAME,
        ]
        : [],
    ];
    filters = handleComplexEnumFilter(complexEnumFilterColumns, filters);

    const url = app.buildDownloadUrl('RiskManagementDevices', 'exportItemsAsCsv', null, 'CSV');
    return Application.lib.DownloadManager.download(url, { filters: filters }, true);
  }

  private async updateWatchlistStatus(newWatchlistStatus: number, indicatorsIds: Array<number>, companyId: string) {
    await updateWatchlist(
      {
        ids: indicatorsIds,
        companyId,
        newWatchlist: newWatchlistStatus,
      },
      this.view.dom.$grid,
      this.view.dom.$sideMenu,
      WEB_COMPONENT_DEVICES_SIDE_MENU,
      'RiskManagementDevices'
    );
  }

  private createIgnoreDialog(endpointsIds: Array<string>, companyId: string) {
    let data: { dialogBodyMessage: any; dialogTitle: any; confirmButtonText: any; toastMessages: any };

    if (endpointsIds.length === 1) {
      data = {
        dialogBodyMessage: `${renderDialogText(
          translateFn(
            'The selected resource will not be included in the overall company risk score calculation. You can revert this action at any time.'
          )
        )}`,
        dialogTitle: translateFn('Ignore resource?'),
        confirmButtonText: translateFn('Ignore resource'),
        toastMessages: {
          success: translateFn('The resource has been ignored. Changes will apply shortly.'),
          error: translateFn('Failed to ignore resource.'),
        },
      };
    } else {
      data = {
        dialogBodyMessage: `${renderDialogText(
          translateFn(
            'The selected resources, while still detected, will not be included in the overall company risk score calculation. You can revert this action at any time.'
          )
        )}`,
        dialogTitle: translateFn('Ignore resources?'),
        confirmButtonText: translateFn('Ignore resources'),
        toastMessages: {
          success: translateFn('The resources have been ignored. Changes will apply shortly.'),
          error: translateFn('Failed to ignore resources.'),
        },
      };
    }

    const requestPayload = {
      parameters: {
        actionType: Actions.IGNORE_DEVICES,
        endpointsIds,
        companyId,
      },
    };

    createActionDialog(
      {
        dialogBodyMessage: data.dialogBodyMessage,
        dialogTitle: data.dialogTitle,
        confirmButtonText: data.confirmButtonText,
      },
      {
        grid: this.view.dom.$grid,
        sideMenu: this.view.dom.$sideMenu,
      },
      requestPayload,
      data.toastMessages
    );
  }

  private createRestoreDialog(endpointsIds: Array<string>, companyId: string) {
    let data: { dialogTitle: any; confirmButtonText: any; dialogBodyMessage: any; toastMessages: any };

    if (endpointsIds.length === 1) {
      data = {
        dialogBodyMessage: `${renderDialogText(
          translateFn(
            'The selected resource will now be included in the overall company risk score calculation. You can revert this action at any time.'
          )
        )}`,
        dialogTitle: translateFn('Restore ignored resource?'),
        confirmButtonText: translateFn('Restore ignored resource'),
        toastMessages: {
          success: translateFn('Ignored resource has been restored. Changes will apply shortly.'),
          error: translateFn('Failed to restore ignored resource.'),
        },
      };
    } else {
      data = {
        dialogBodyMessage: `${renderDialogText(
          translateFn(
            'The selected resources will now be included in the overall company risk score calculation. You can revert this action at any time.'
          )
        )}`,
        dialogTitle: translateFn('Restore ignored resources?'),
        confirmButtonText: translateFn('Restore ignored resources'),
        toastMessages: {
          success: translateFn('Ignored resources have been restored. Changes will apply shortly.'),
          error: translateFn('Failed to restore ignored resources.'),
        },
      };
    }

    const requestPayload = {
      parameters: {
        actionType: Actions.RESTORE_DEVICES,
        endpointsIds,
        companyId,
      },
    };
    createActionDialog(
      {
        dialogTitle: data.dialogTitle,
        confirmButtonText: data.confirmButtonText,
        dialogBodyMessage: data.dialogBodyMessage,
      },
      {
        grid: this.view.dom.$grid,
        sideMenu: this.view.dom.$sideMenu,
      },
      requestPayload,
      data.toastMessages
    );
  }

  private handleFixBulkButtonClick(event: CustomEvent) {
    if (this.selectedItems.length === 0) {
      return;
    }

    const { companyId, hasFrat } = this.selectedItems[0];
    const endpointIds = this.selectedItems.map(item => item.endpointId);

    this.createFixDialog([], endpointIds, companyId, hasFrat);
  }

  private handleSelectionChange(event: CustomEvent) {
    handleSelectionChange.call(this, event);
    this.calculateFixBulkButtonAvailability(this.view.dom.fixBulk);
  }

  private calculateFixBulkButtonAvailability(fixBulk: {
    $button: { disabled: boolean };
    $tooltip: { tooltipText: string };
  }) {
    if (this.selectedItems.length > 0 && !this.selectedItems[0]['company']['specifics']['features']['iorUsable']) {
      fixBulk.$button.disabled = true;
      fixBulk.$tooltip.tooltipText = translateFn('Your current license does not provide access to this feature.');
      return;
    }

    fixBulk.$tooltip.tooltipText = '';

    // Get items that are not cloud resources and that has misconfigurations
    const endpointResourcesWithMisconfigurations = this.selectedItems.filter(item => {
      if (item.misconfigurationIds.length === 0) {
        return false;
      }

      if (isCloudResource(item.endpointType)) {
        return false;
      }

      return true;
    });

    fixBulk.$button.disabled = endpointResourcesWithMisconfigurations.length === 0;
  }

  private handleRollbackDevicesEvent(event: CustomEvent) {
    const { endpointId, endpointName, companyId, hasFrat } = event.detail;
    this.createRollbackRiskDialog(endpointId, endpointName, companyId, hasFrat);
  }

  private async handleRollbackDevicesInlineEvent(event: CustomEvent) {
    let countRisksToRollback = 0;

    try {
      countRisksToRollback = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'CompanyEndpointRollbackState',
        method: 'countRisksToRollbackByEndpointId',
        payload: {
          companyId: event.detail.companyId,
          endpointId: event.detail.endpointId,
        },
      });
    } catch (e) {
      countRisksToRollback = 0;
    }

    if (countRisksToRollback > 0) {
      this.handleRollbackDevicesEvent(event);
    } else {
      showToast(
        ToastSeverity.ERROR,
        translateFn('Rolling back is not available for any risks associated with this endpoint.')
      );
    }
  }

  private async createRollbackRiskDialog(
    endpointId: string,
    endpointName: string,
    companyId: string,
    hasFrat: boolean | undefined
  ) {
    if (hasFrat) {
      createFratDialog();
      return;
    }

    const { risksOptions, risksOptionsErrorState } = await this.getRisksOptions(endpointId, companyId);

    if (isEmpty(risksOptions)) {
      showToast(
        ToastSeverity.ERROR,
        translateFn('Rolling back is not available for any risks associated with this endpoint.')
      );
      return;
    }

    const dialogBody = document.createElement('div');

    const riskSelection = new GzSelectedListItemGeneratorWebComponent();
    riskSelection.filterOptions = risksOptions;
    riskSelection.canSelectAll = true;
    riskSelection.classList.add('mt-1');
    riskSelection.style.cssText = '--body-size-large: var(--body-size); margin-left: -8px;';
    riskSelection.strings = {
      sectionLeftTitle: translateFn('Risks'),
      sectionRightTitle: translateFn('Selected risks'),
      searchPlaceholderString: 'Search',
      noSearchResultsString: 'No results found',
      allLabel: 'All risks',
      emptyStateText: 'No risks selected',
    };

    riskSelection.addEventListener(EventTypes.CHANGE_SELECTED, () => {
      if (this.confirmButton) {
        this.confirmButton.disabled = isEmpty(riskSelection.getSelectedValues());
      }
    });

    const result = [
      `<gz-text fontSize="${FontSizes.HEADING_6}">${translateFn(
        'The following recommended settings will be removed for {endpointName}',
        { endpointName }
      )}
       </gz-text>
       <br>
       <gz-text fontSize="${FontSizes.HEADING_6}">${translateFn(
        'A task will be created to revert the settings on the endpoint.'
      )}</gz-text>
       <br>
       <br>
       <gz-text class="subtitle" fontSize="${FontSizes.HEADING_5}" fontWeight="${FontWeights.SEMIBOLD} ">${translateFn(
        'Targets'
      )}</gz-text>
       <br>
       <gz-text fontSize="${FontSizes.HEADING_6}">${translateFn(
        'Select the risks you want to roll back for this endpoint.'
      )}</gz-text>
      <br>`,
    ];

    dialogBody.className = 'dialogBody mt-3 mb-6 ml-5 mr-6 w-60';
    dialogBody.innerHTML = [...result].join('');
    dialogBody.appendChild(riskSelection);

    const dialogFooter = document.createElement('div');

    this.confirmButton = new GzButtonWebComponent();
    this.confirmButton.innerText = translateFn('Roll back fixes');
    this.confirmButton.setAttribute('color', 'primary');
    this.confirmButton.setAttribute('class', 'mr-2');
    this.confirmButton.disabled = true;
    dialogFooter.appendChild(this.confirmButton);

    const cancelButton = new GzButtonWebComponent();
    cancelButton.innerText = translateFn('Cancel');
    cancelButton.setAttribute('type', 'outline');
    cancelButton.setAttribute('color', 'secondary');
    dialogFooter.appendChild(cancelButton);

    const dialogTitle = `Roll back fixes?`;

    const dialogConfigs: GzDialog = {
      headline: dialogTitle,
      bodyContent: dialogBody,
      footerContent: dialogFooter,
      isOpen: true,
      isWindow: true,
      closableOutsideBox: false,
    };

    const dialog = GzDialogWebComponent.buildDialogElement(
      dialogConfigs,
      document.querySelector('.mainContainer') as HTMLElement
    );

    const toastMessages = {
      success: translateFn('The task has been successfully created.'),
      error: translateFn('Failed to create task.'),
    };

    this.confirmButton.addEventListener('click', async () => {
      if (this.confirmButton.showSpinner) {
        return;
      }

      try {
        this.confirmButton.showSpinner = true;

        const requestPayload = {
          parameters: {
            actionType: Actions.ROLLBACK_FIXES,
            indicatorsIds: riskSelection.getSelectedValues(),
            companyId: companyId,
            endpointsIds: [endpointId],
          },
        };

        await ConsoleRequest.createRequest<any>({
          dataProviderType: DataProviderType.ENDPOINTS,
          endpoint: 'RiskManagementActions',
          method: 'performAction',
          payload: requestPayload,
        });

        GzToastNotificationWebComponent.buildToastWrapperElement({
          message: toastMessages.success,
          severity: ToastSeverity.SUCCESS,
          actionButtonText: translateFn('View status.'),
          hasAction: true,
          actionButtonMode: ToastActionButtonMode.LINK,
          actionCallback: () => {
            navigateToTasksSection();
            GzToastNotificationWebComponent.closeAllToasts();
          },
        });
      } catch (error) {
        GzToastNotificationWebComponent.closeAllToasts();
        if (error.err?.exceptionType === 'Exceptions\\NoTargetsFoundException') {
          toastMessages.error = translateFn('Failed to create task. No valid targets found.');
        }
        showToast(ToastSeverity.ERROR, toastMessages.error);
      } finally {
        dialog.close();
        this.view.dom.$sideMenu.closeSideMenu();
        this.view.dom.$grid.controller.resetSelection();
      }
    });

    cancelButton.addEventListener('click', () => {
      dialog.close();
    });
  }

  private async getRisksOptions(endpointId, companyId) {
    const risksOptions: SelectedListItem[] = [];
    let risksOptionsErrorState = true;
    let risksOptionsIds = [];

    try {
      risksOptionsIds = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'CompanyEndpointRollbackState',
        method: 'getRisksToRollbackByEndpointId',
        payload: {
          companyId: companyId,
          endpointId: endpointId,
        },
      });
      risksOptionsErrorState = false;
    } catch (e) {
      risksOptionsErrorState = true;
    }

    for (const riskId of risksOptionsIds) {
      risksOptions.push({
        label: MisconfigurationsNames.getLabelsCallback(riskId),
        value: riskId,
      });
    }

    return { risksOptions, risksOptionsErrorState };
  }
}
